import { render, staticRenderFns } from "./ClassCateKcList.vue?vue&type=template&id=3f59b58a&scoped=true&"
import script from "./ClassCateKcList.vue?vue&type=script&lang=js&"
export * from "./ClassCateKcList.vue?vue&type=script&lang=js&"
import style0 from "./ClassCateKcList.vue?vue&type=style&index=0&id=3f59b58a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f59b58a",
  null
  
)

export default component.exports